import { render, staticRenderFns } from "./wcrd_workcards.vue?vue&type=template&id=a11fd53c&scoped=true&"
import script from "./wcrd_workcards.vue?vue&type=script&lang=js&"
export * from "./wcrd_workcards.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_workcards.vue?vue&type=style&index=0&id=a11fd53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11fd53c",
  null
  
)

export default component.exports